import React from "react";
import {isMobile} from 'react-device-detect';

function Container(props) {
  return (
    <div style={{ margin: "0px auto", maxWidth: "1280px", padding: (props.nopadding ? "0px" : isMobile ? "10px":"25px")}}>    
        {props.children}
    </div>
  );
}

export default Container;